import { Button, Card } from "react-bootstrap";
import { ChatRightText, XCircle } from "react-bootstrap-icons";

const TicketNotification = (props) => {
    const { notif, remove, openProfile, getDestUrl } = props;
    const goToEditPage = () => {
        remove(notif.ID);
        openProfile(notif.CustomerID, notif.Type);
    }
    return (
        <Card className="notification-card">
            <Card.Header>
                <label>
                    <ChatRightText color="#008074" />&nbsp;{notif.Type === "NewTicket" ? "تیکت جدید" : "پاسخ به تیکت"}</label>
                <label style={{ float: "left", marginRight: "20px" }} onClick={() => remove(notif.ID)}><XCircle color="red" size={17} style={{ cursor: "pointer" }} /></label>

            </Card.Header>
            <Card.Body className="row">
                <div className="col-6 mt-1" >شناسه تیکت: </div><div className="col-6 mt-1" style={{ padding: 0 }}> {notif.TicketID} </div>
                <div className="col-6 mt-1" >نام مشتری: </div><div className="col-6 mt-1" style={{ padding: 0 }}> {notif.CustomerName} </div>
                <div className="mt-2">
                    <a href={getDestUrl(notif.CustomerID, notif.Type)}><Button className="group-Btn-smalll w-100" onClick={goToEditPage}>پرونده مشتری</Button></a>
                </div>
            </Card.Body>
        </Card>
    )
}
export default TicketNotification;